// jQuery(document).ready(function() {
//     var owl = jQuery('.CarouselBanner1');
//     owl.owlCarousel({
//         margin: 0,
//         loop: true,
//         dots:true,
//         autoplayHoverPause: true,
//         responsive: {
//             0: {
//                 items: 1
//             },
//             480: {
//                 items: 1
//             },
//             576: {
//                 items: 1
//             },
//             768: {
//                 items: 3
//             },
//             992: {
//                 items: 4
//             },
//             1200: {
//                 items: 4
//             }
//         }
//     })
// })


(function() {
  document.addEventListener('ajaxProduct:added', async function(evt) {
    const cart = await getCart()
    if (!cart) return
    checkOrphanBundleItems(cart.items)

  }.bind(this));
  document.addEventListener('cart:updated', async function(evt) {
    const cart = await getCart()
    if (!cart) return
    checkOrphanBundleItems(cart.items)

  }.bind(this));

  async function getCart() {
    return await theme.cart.getCart()
  }

  // Rebuy event listeners
  document.addEventListener("rebuy:cart.ready", (event) => {
    const lineItems = event.detail?.cart?.cart?.items;
    if (!lineItems) return;
    checkOrphanBundleItems(lineItems);
  });
  document.addEventListener("rebuy:cart.change", (event) => {
    const lineItems = event.detail?.cart?.cart?.items;
    if (!lineItems) return;
    checkOrphanBundleItems(lineItems);
  });

  /**
   * Checks for unlinked bundle items in cart
   * @param {Array} lineItems - Cart items
   */
  const checkOrphanBundleItems = (lineItems) => {
    if (!lineItems || lineItems.length <= 0) return;

    let bundleItems = [...lineItems].map((item) => item?.properties?._bundle_id);
    let bundleIDs = bundleItems.filter((id) => id);
    let orphanBundleIDs = [];

    if (!bundleIDs || bundleIDs.length <= 0) return;
    bundleIDs.forEach((bundleID) => {
      let bundleMin = 0;
      let bundleMax = 0;
      let bundleCount = 0;
      const hasChildProduct = lineItems.filter(
        (item) => item.properties?._bundle_id == bundleID && !item?.properties?._bundle_parent,
      );
      const hasParentProduct = lineItems.find(
        (item) => item.properties?._bundle_id == bundleID && item?.properties?._bundle_parent === true,
      );

      if (!hasChildProduct || hasChildProduct.length <= 0 || !hasParentProduct) {
        orphanBundleIDs.push(bundleID);
        return;
      }

      bundleMin = parseInt(hasParentProduct.properties?._bundle_min) || bundleMin;
      bundleMax = parseInt(hasParentProduct.properties?._bundle_max) || bundleMax;
      bundleCount = hasChildProduct.reduce((acc, item) => acc + parseInt(item.quantity), 0) || bundleCount;

      if (bundleCount < bundleMin || bundleCount > bundleMax) {
        orphanBundleIDs.push(bundleID);
      }
    });
    if (orphanBundleIDs.length <= 0) return;

    deleteOrphanBundleProducts(lineItems, orphanBundleIDs);
  };

  /**
   * Removes all unlinked bundle products
   * @param {Array} cart - Cart line items
   * @param {Array} orphanBundleIDs - Array of unlinked products to delete
   */
  const deleteOrphanBundleProducts = (cart, orphanBundleIDs) => {
    const { Rebuy } = window;
      console.log('deleting orphans')
      const submitButton = document.querySelector('.lsg-bundle-submit-button');
    let orphanData = {
      updates: {},
    };

    orphanBundleIDs.forEach((bundleID) => {
      cart.map((item) => {
        if (!item || item?.properties?._bundle_id !== bundleID) return;
        orphanData["updates"][String(item.key)] = 0;
      });
    });

    fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "xmlhttprequest",
      },
      body: JSON.stringify(orphanData),
    })
      .then(res => res.json())
      .then((response) => {
        if (!Rebuy) {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: {
              product: response.items,
              addToCartBtn: submitButton
            }
          }));
        }
      })
      .catch((error) => {
        console.error("Error removing bundle product from cart:", error);
      });
  }
})()